import {useIsPrive} from 'core/hooks/useIsPrive';

export const useIsProductAvailableForUser = (canBuy?: boolean, canReserve?: boolean) => {
    const isPrive = useIsPrive();

    if (isPrive) {
        return canBuy;
    }

    return canBuy || canReserve;
};
